var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMsg = function SvgMsg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 36,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#msg_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.314 34.202h41.4a.9.9 0 0 0 .9-.9V3.074L24.651 24.037a.897.897 0 0 1-1.272 0L2.414 3.074v30.228a.9.9 0 0 0 .9.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.327 1.797H3.672l20.327 20.327z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "M44.686 0h-41.4a2.703 2.703 0 0 0-2.7 2.7v30.6c0 1.489 1.211 2.7 2.7 2.7h41.4c1.489 0 2.7-1.211 2.7-2.7V2.7c0-1.489-1.212-2.7-2.7-2.7m-.373 1.8L23.986 22.127 3.659 1.8zM2.386 33.3a.9.9 0 0 0 .9.9h41.4a.9.9 0 0 0 .9-.9V3.073L24.62 24.035a.896.896 0 0 1-1.272 0L2.386 3.073z",
    clipRule: "evenodd",
    opacity: 0.67
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "msg_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.586 0h46.8v36H.586z"
  })))));
};
export default SvgMsg;